import { useLocalization } from '@/pages-hooks'
import { getLcidFromRouteParams } from '@/pages-hooks/route-params'

export default defineNuxtRouteMiddleware(async (to, from) => {
  // if (import.meta.client) {
  //   useLocalization().restoreLocale()
  // } else {
  await useLocalization().setLocale(getLcidFromRouteParams(to.params))
  //}
})
